// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-merge-request-review .work-merge-panel-header {
  display: flex;
  flex-direction: column;
  margin-top: 7.7rem;
  margin-bottom: 2.7rem;
}
.work-merge-request-review .work-merge-panel-header p {
  font-size: 14px;
}
.work-merge-request-review .work-merge-panel-list {
  gap: 3.2rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/WorkMerge/WorkMergeSearch/components/WorkMergePanel/WorkMergeRequestReview/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;AAAJ;AAEI;EACE,eAAA;AAAN;AAIE;EACE,WAAA;AAFJ","sourcesContent":[".work-merge-request-review {\n  .work-merge-panel-header {\n    display: flex;\n    flex-direction: column;\n    margin-top: 7.7rem;\n    margin-bottom: 2.7rem;\n\n    p {\n      font-size: 14px;\n    }\n  }\n\n  .work-merge-panel-list {\n    gap: 3.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
